import { Slide } from '@widgets/Gallery/types'
import { useEffect, useMemo, useState } from 'react'
import {
  ScribbleCollection,
  ScribbleCollectionItem,
  UseScribbleFetcherProps,
} from './types'
import { formatItem, parseUrl } from './utils'

const useScribbleFetcher: UseScribbleFetcherProps = (url) => {
  const [items, setItems] = useState<Slide[]>([])
  const { galleryId, token } = useMemo(() => parseUrl(url), [url])

  useEffect(() => {
    fetch(
      `https://api.scribblelive.com/v1/collection/${galleryId}?token=${token}&MaxItems=100&timestamp=${Date.now()}`
    )
      .then((response) => response.json())
      .then((res) => {
        const {
          CollectionItems: items,
        }: {
          Collection: ScribbleCollection
          CollectionItems: ScribbleCollectionItem[]
        } = res

        setItems(items.map(formatItem))
      })
      .catch((_err) => {
        //error
      })
  }, [galleryId, token])

  return { galleryId, items }
}

export default useScribbleFetcher
